import React from 'react';

import css from './StarRating.module.css';

interface IProps {
  starsSelected: number;
}

const StarRating: React.FC<IProps> = ({ starsSelected }) => {
  return (
    <div className={css.starRating}>
      {[...Array(5)].map((_n, i) => {
        const activeClass = i < starsSelected ? css.starActive : '';
        return <div className={`${css.star} ${activeClass}`} key={i} />;
      })}
    </div>
  );
};
export default StarRating;
